import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useMemo } from 'react';
import { styled } from '@mui/material/styles';
import { useLocalizationContext, Translate } from '@im/react-localization';
import { SelectOption } from '../SelectOption/SelectOption';
import { jsx as _jsx } from "react/jsx-runtime";
export function CulturePickerNew(props) {
  var context = useLocalizationContext();
  var supportedLocales = context.supportedLocales;
  var MenuProps = props.MenuProps,
    _props$dataTestid = props['data-testid'],
    testid = _props$dataTestid === void 0 ? 'required' : _props$dataTestid;
  var options = useMemo(function () {
    return supportedLocales ? supportedLocales.map(function (locale) {
      return {
        label: /*#__PURE__*/_jsx(Translate, {
          text: "Culture.".concat(locale)
        }),
        value: locale
      };
    }) : [];
  }, [supportedLocales]);
  if (!supportedLocales || supportedLocales.length < 2) {
    return null;
  }
  return /*#__PURE__*/_jsx(StyleSelectOption, _extends({
    MenuProps: MenuProps,
    onChange: function onChange(e) {
      return context.setLocale(e.target.value);
    },
    options: options,
    value: context.locale
  }, props, {
    "data-testid": "".concat(testid, "-CulturePicker"),
    "data-element": "StyleSelectOption",
    "data-component": "CulturePickerNew",
    "data-source-file": "CulturePickerNew.tsx"
  }));
}
var StyleSelectOption = styled(SelectOption)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    },
    '& .MuiSelect-icon': {
      color: 'inherit',
      fontSize: '24px'
    },
    color: theme.palette.grey[600],
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '22px',
    width: 'auto'
  };
});